const flexGen = (justify = 'flex-start', align = 'flex-start', direction = 'row', wrap = 'nowrap'): string => `display: flex; flex-direction: ${direction}; flex-wrap: ${wrap}; justify-content: ${justify}; align-items: ${align};`;

export default flexGen;
